import {Dispatch, FC, Fragment, SetStateAction, useEffect, useState} from 'react'
import {Invoice} from '../../core/_models'
import clsx from 'clsx'
import {
  SearchSelect,
  SearchSelectOption,
} from '../../../../../../../_metronic/helpers/components/SearchSelect'
import {useListView} from '../../core/ListViewProvider'
import {CustomInputs} from '../../../../../../../_metronic/helpers/components/CustomInputs'
import {CustomerEditModal} from '../../../../customer-management/customers-list/customer-edit-modal/CustomerEditModal'
import {API_URL, isNotEmpty} from '../../../../../../../_metronic/helpers'
import axios from 'axios'
import {
  getReferencedInvoiceMinimumDate,
  REFERENCED_INVOICE_DATE_HINT,
} from '../../core/invoiceReferenceDate'
import {InvoiceDateDeadlineHint} from '../../components/InvoiceDateDeadlineHint'
import {
  InvoiceArticle9IssueDateAccessory,
  InvoiceArticle9RegistrationField,
} from '../../components/InvoiceArticle9Fields'
import {isInvoiceTypeAvailableForTemplate} from '../../core/invoiceTypeAvailability'
import {isInvoiceBuyerRequired, optionalBuyerHint} from '../../core/invoiceBuyerRequirement'
import {
  InvoiceRulesV79,
  getInvoiceFieldRule,
  isInvoiceFieldReadOnly,
  isInvoiceFieldRequired,
  isInvoiceFieldVisible,
} from '../../core/invoiceRulesV79'
import {AutoOpenOptionalSection} from '../AutoOpenOptionalSection'
import {ShipmentLocationSelect} from '../ShipmentLocationSelect'
import {isShipmentCityRequired} from '../../core/shipmentLocationCodes'
import {getDriverIdCodeValidationError} from '../../core/invoicePatternValidation'

type FieldState = {
  value: string
  setValue: Dispatch<SetStateAction<string>>
}

type props = {
  invoice: Invoice | null | undefined
  no: {
    no: string
    setNo: Dispatch<SetStateAction<string>>
  }
  buyer: {
    buyer: string
    setBuyer: Dispatch<SetStateAction<string>>
  }
  buyerDescription: {
    buyerDescription: string
    setBuyerDescription: Dispatch<SetStateAction<string>>
  }
  date: {
    date: string
    setDate: Dispatch<SetStateAction<string>>
  }
  invoiceType: {
    invoiceType: number
    setInvoiceType: Dispatch<SetStateAction<number>>
  }
  invoiceTemplate: number
  contractCode: {
    contractCode: string
    setContractCode: Dispatch<SetStateAction<string>>
  }
  stockExchangeInfo: {
    saleAnnNo: string
    setSaleAnnNo: Dispatch<SetStateAction<string>>
    saleAnnDate: string
    setSaleAnnDate: Dispatch<SetStateAction<string>>
  }
  patternFields: {
    declarationNo: FieldState
    officeCode: FieldState
    billNo: FieldState
    cottageNo: FieldState
    cottageDate: FieldState
    insPolicyNo: FieldState
    extInsPolicyNo: FieldState
    flightType: FieldState
    flightBuyerMethod: FieldState
    flightNationalId: FieldState
    flightForeignId: FieldState
    flightPassportNumber: FieldState
    flightFirstName: FieldState
    flightLastName: FieldState
    flightEconomicCode: FieldState
    flightAgentName: FieldState
    flightAgentEconomicCode: FieldState
    shipmentBlNumber: FieldState
    shipmentRefBlNumber: FieldState
    shipmentOriginCountry: FieldState
    shipmentOriginCity: FieldState
    shipmentDestinationCountry: FieldState
    shipmentDestinationCity: FieldState
    shipmentSenderEconomicCode: FieldState
    shipmentReceiverEconomicCode: FieldState
    shipmentTransportType: FieldState
    shipmentFleetNumber: FieldState
    shipmentDriverIdCode: FieldState
    shipmentTotalWeight: FieldState
  }
  now: string
  fiscalMemoryId?: number
  rules?: InvoiceRulesV79
  article9?: {
    isArticle9: boolean
    setIsArticle9: Dispatch<SetStateAction<boolean>>
    registrationDateTime: string
    setRegistrationDateTime: Dispatch<SetStateAction<string>>
  }
  // «پیش‌فاکتور»: numbered in its own line, apart from the invoices.
  proforma?: boolean
}

const Step1: FC<props> = ({
  invoiceType,
  invoiceTemplate,
  no,
  buyer,
  date,
  buyerDescription,
  contractCode,
  stockExchangeInfo,
  patternFields,
  invoice,
  now,
  fiscalMemoryId,
  rules,
  article9,
  proforma = false,
}) => {
  const {shareData, variableD} = useListView()
  const minimumReferenceDate = getReferencedInvoiceMinimumDate(invoice, variableD)
  const supportsTypeTwo = isInvoiceTypeAvailableForTemplate(2, invoiceTemplate)
  const isBuyerRequired = isInvoiceBuyerRequired(invoiceType.invoiceType, invoiceTemplate)
  const setInvoiceType = invoiceType.setInvoiceType
  const [buyerSearch, setBuyerSearch] = useState<SearchSelectOption>()
  const [_invoiceType, set_InvoiceType] = useState(
    invoiceType.invoiceType === 1 || !supportsTypeTwo ? 1 : 0
  )
  const [noError, setNoError] = useState('')
  const notNew = invoice != null && invoice != undefined && invoice.ph && invoice.ph.i > 1
  const notEditableElement = (
    <label title='غیر قابل ویرایش' className='fw-bold fs-6 mb-2 ms-2 text-warning'>
      !
    </label>
  )

  const [addCustomer, setAddCustomer] = useState(false)
  const fieldVisible = (jsonName: string, legacyValue: boolean) =>
    isInvoiceFieldVisible(rules, jsonName, legacyValue)
  const fieldRequired = (jsonName: string, legacyValue = false) =>
    isInvoiceFieldRequired(rules, jsonName, legacyValue)
  const fieldReadOnly = (jsonName: string) => isInvoiceFieldReadOnly(rules, jsonName)

  useEffect(() => {
    buyer.setBuyer(buyerSearch?.value || '')
  }, [buyerSearch])

  useEffect(() => {
    //console.log('shareData', shareData);
  }, [shareData])

  useEffect(() => {
    if (!supportsTypeTwo) {
      if (_invoiceType === 0) {
        set_InvoiceType(1)
      }
      setInvoiceType(1)
      return
    }

    setInvoiceType(_invoiceType === 0 ? 2 : 1)
  }, [_invoiceType, setInvoiceType, supportsTypeTwo])

  const checkNo = () => {
    if (!(invoice && invoice.id) && isNotEmpty(no.no)) {
      axios
        .get(`${API_URL}/invoices/checkNo/`, {
          params: {
            no: no.no,
            date: date.date || '',
            subject: variableD || 1,
            // بررسی تکراری‌بودن شماره در محیط همان حافظه (عملیاتی/سندباکس) انجام می‌شود.
            fiscalMemoryId: fiscalMemoryId || 0,
            // پیش‌فاکتورها شماره‌گذاری جداگانه دارند و فقط با یکدیگر مقایسه می‌شوند.
            ...(proforma ? {proforma: true} : {}),
          },
        })
        .then((response) => {
          setNoError('')
        })
        .catch((error) => {
          setNoError(
            proforma
              ? 'این شمارهٔ پیش‌فاکتور در سال مالی جاری قبلاً ثبت شده است؛ شمارهٔ دیگری وارد کنید.'
              : 'این شماره صورتحساب در سال مالی جاری، با همین موضوع و در همین محیط (عملیاتی یا سندباکس) قبلا ثبت شده است'
          )
        })
    }
  }

  const ebtal = () => {}

  const buyerType2Hint = (
    <>
      <span className='text-gray-600 fs-7'>
        <i className='las la-info text-info fs-5'></i>
        فقط جهت نمایش در صورتحساب چاپی
      </span>
    </>
  )
  const buyerOptionalHint = (
    <span className='text-gray-600 fs-7'>
      <i className='las la-info text-info fs-5'></i>
      {optionalBuyerHint(invoiceTemplate)}
    </span>
  )

  const contractCodeHint = (
    <>
      <span className='text-gray-600 fs-8' style={{textAlign: 'justify'}}>
        <i className='las la-info text-info fs-5'></i>
        این شناسه{' '}
        <span className='text-gray-800' style={{textDecoration: 'underline'}}>
          12 رقمی
        </span>{' '}
        باید با شماره قرارداد موجود در کارپوشه مودیان که قبلاً توسط کسب و کار ثبت شده، یکسان باشد.
      </span>
    </>
  )

  const optionalCustomsHint = (
    <span className='text-gray-600 fs-8'>
      مطابق سند V7.9 این فیلد برای این الگو اختیاری است؛ در صورت ورود باید عددی و مطابق اطلاعات گمرک
      باشد.
    </span>
  )

  const requiredByDocumentHint = (
    <span className='text-gray-600 fs-8'>طبق سند V7.9 برای این الگو الزامی است.</span>
  )

  const hasValue = (value: unknown) =>
    value !== undefined && value !== null && String(value).trim() !== ''
  const isOptionalField = (jsonName: string, legacyVisible: boolean, legacyRequired = false) =>
    fieldVisible(jsonName, legacyVisible) &&
    (rules?.enabled ? getInvoiceFieldRule(rules, jsonName)?.status === 'Optional' : !legacyRequired)
  const isPrimaryField = (jsonName: string, legacyVisible: boolean, legacyRequired = false) =>
    fieldVisible(jsonName, legacyVisible) &&
    !isOptionalField(jsonName, legacyVisible, legacyRequired)
  const hasOptionalData =
    (!isBuyerRequired &&
      (hasValue(buyer.buyer) || hasValue(buyerSearch?.value) || hasValue(invoice?.buci))) ||
    [
      patternFields.flightFirstName.value,
      patternFields.flightLastName.value,
      patternFields.flightEconomicCode.value,
      patternFields.flightAgentName.value,
      patternFields.flightAgentEconomicCode.value,
      patternFields.shipmentRefBlNumber.value,
      patternFields.shipmentTotalWeight.value,
      buyerDescription.buyerDescription,
    ].some(hasValue) ||
    (isOptionalField('scln', [1, 2].includes(invoiceTemplate)) &&
      hasValue(patternFields.declarationNo.value)) ||
    (isOptionalField('scc', [1, 2, 7].includes(invoiceTemplate)) &&
      hasValue(patternFields.officeCode.value)) ||
    (isOptionalField('cdcn', invoiceTemplate === 7) && hasValue(patternFields.cottageNo.value)) ||
    (isOptionalField('cdcd', invoiceTemplate === 7) && hasValue(patternFields.cottageDate.value)) ||
    (isOptionalField('billid', invoiceTemplate === 5, true) &&
      hasValue(patternFields.billNo.value)) ||
    (isOptionalField('asn', invoiceTemplate === 11, true) &&
      hasValue(stockExchangeInfo.saleAnnNo)) ||
    (isOptionalField('asd', invoiceTemplate === 11, true) &&
      hasValue(stockExchangeInfo.saleAnnDate)) ||
    (isOptionalField('in', invoiceTemplate === 13, true) &&
      hasValue(patternFields.insPolicyNo.value)) ||
    (isOptionalField('an', invoiceTemplate === 13) &&
      hasValue(patternFields.extInsPolicyNo.value)) ||
    (isOptionalField(
      'crn',
      invoiceType.invoiceType === 1 && [1, 2, 3, 4].includes(invoiceTemplate),
      invoiceTemplate === 4
    ) &&
      hasValue(contractCode.contractCode))

  const buyerField = (
    <div className={clsx('col-12 mt-7')}>
      <SearchSelect
        section='buyer'
        label={
          <span>
            خریدار {!isBuyerRequired && <span className='text-gray-500 fs-7'>(اختیاری)</span>}
            {invoiceType.invoiceType == 1 && notNew && notEditableElement}
          </span>
        }
        isDisabled={invoiceType.invoiceType == 1 && notNew}
        placeholder='برای انتخاب خریدار جستجو کنید...'
        stateValue={{value: buyerSearch, setValue: setBuyerSearch}}
        isRequired={isBuyerRequired && !notNew}
        hint={
          invoiceType.invoiceType == 1
            ? isBuyerRequired
              ? ''
              : buyerOptionalHint
            : buyerType2Hint
        }
        defaultvalue={invoice?.buci}
      >
        <button
          type='button'
          className='btn btn-icon btn-light-success mp-add-buyer'
          title='تعریف خریدار جدید'
          aria-label='تعریف خریدار جدید'
          onClick={() => setAddCustomer(true)}
        >
          <i className='las la-plus fs-2' aria-hidden='true'></i>
        </button>
      </SearchSelect>
    </div>
  )

  return (
    <>
      <div className='fv-row mb-7'>
        <div className='row'>
          <div className='col-6 mt-7'>
            <CustomInputs
              type='text'
              label={
                <>شماره مسلسل {variableD == 2 ? 'اصلاحی' : variableD == 4 ? 'برگشت از فروش' : ''}</>
              }
              isRequired
              stateValue={{value: no.no, setValue: no.setNo}}
              error={noError}
              onKeyDownFn={() => {
                setNoError('')
              }}
              onBlurFn={checkNo}
            />
          </div>
          <div className='col-6 mt-7'>
            <CustomInputs
              type='datepicker'
              label={
                <>
                  تاریخ و زمان صدور صورتحساب{' '}
                  {variableD == 2 ? 'اصلاحی' : variableD == 4 ? 'برگشت از فروش' : ''}
                </>
              }
              labelAccessory={
                article9 ? (
                  <InvoiceArticle9IssueDateAccessory
                    invoiceType={invoiceType.invoiceType}
                    issueDateTime={date.date}
                    isArticle9={article9.isArticle9}
                    setIsArticle9={article9.setIsArticle9}
                  />
                ) : (
                  <InvoiceDateDeadlineHint date={date.date} />
                )
              }
              isRequired
              timePicker
              limitFromDate={minimumReferenceDate}
              stateValue={{value: date.date, setValue: date.setDate}}
              limitToDate={now}
              hint={minimumReferenceDate ? REFERENCED_INVOICE_DATE_HINT : undefined}
            />
          </div>
          {article9 && (article9.isArticle9 || invoiceType.invoiceType === 3) && (
            <div className='col-6 mt-7'>
              <InvoiceArticle9RegistrationField
                invoiceType={invoiceType.invoiceType}
                issueDateTime={date.date}
                now={now}
                isArticle9={article9.isArticle9}
                setIsArticle9={article9.setIsArticle9}
                registrationDateTime={article9.registrationDateTime}
                setRegistrationDateTime={article9.setRegistrationDateTime}
              />
            </div>
          )}
          {supportsTypeTwo && (
            <div className='col-12 mt-7'>
              <CustomInputs
                type='toggle'
                label={<>نوع صورتحساب {notNew && notEditableElement}</>}
                isDisabled={notNew}
                isRequired={!notNew}
                stateValue={{value: _invoiceType, setValue: set_InvoiceType}}
                toggleValue={{
                  off: 'صورتحساب نوع دوم (بدون اطلاعات خریدار)',
                  on: 'صورتحساب نوع اول (با اطلاعات خریدار)',
                }}
              />
            </div>
          )}
          {isBuyerRequired && buyerField}
          {invoiceTemplate == 6 && (
            <>
              <div className='col-6 mt-7'>
                <CustomInputs
                  type='radio'
                  label={<>نوع پرواز</>}
                  isRequired
                  stateValue={{
                    value: patternFields.flightType.value,
                    setValue: patternFields.flightType.setValue,
                  }}
                  hint={requiredByDocumentHint}
                  items={[
                    {
                      label: 'پرواز داخلی',
                      value: '1',
                    },
                    {
                      label: 'پرواز خارجی',
                      value: '2',
                    },
                  ]}
                />
              </div>
              <div className='col-6 mt-7'>
                <CustomInputs
                  type='radio'
                  label={<>روش شناسایی مسافر</>}
                  isRequired
                  stateValue={{
                    value: patternFields.flightBuyerMethod.value,
                    setValue: patternFields.flightBuyerMethod.setValue,
                  }}
                  items={[
                    {label: 'شماره ملی', value: '1'},
                    {label: 'کد فراگیر', value: '2'},
                    {label: 'گذرنامه', value: '3'},
                  ]}
                />
              </div>
              {patternFields.flightBuyerMethod.value == '1' && (
                <div className='col-6 mt-7'>
                  <CustomInputs
                    type='text'
                    numberAsText
                    digitsOnly
                    isRequired={patternFields.flightType.value == '1'}
                    label={<>شماره ملی مسافر</>}
                    stateValue={patternFields.flightNationalId}
                    max={10}
                    hint={requiredByDocumentHint}
                  />
                </div>
              )}
              {patternFields.flightBuyerMethod.value == '2' && (
                <div className='col-6 mt-7'>
                  <CustomInputs
                    type='text'
                    numberAsText
                    digitsOnly
                    isRequired={patternFields.flightType.value == '1'}
                    label={<>کد فراگیر اتباع غیرایرانی مسافر</>}
                    stateValue={patternFields.flightForeignId}
                    max={12}
                    hint={requiredByDocumentHint}
                  />
                </div>
              )}
              {patternFields.flightBuyerMethod.value == '3' && (
                <div className='col-6 mt-7'>
                  <CustomInputs
                    type='text'
                    numberAsText
                    isRequired
                    label={<>شماره گذرنامه مسافر</>}
                    stateValue={patternFields.flightPassportNumber}
                    max={9}
                    hint={
                      <span className='text-gray-600 fs-8'>
                        برای مسافر غیرایرانی غیرمقیم در پرواز خارجی استفاده شود.
                      </span>
                    }
                  />
                </div>
              )}
            </>
          )}
          {isPrimaryField('scln', [1, 2].includes(invoiceTemplate)) && (
            <>
              <div className='col-6 mt-7'>
                <CustomInputs
                  type='text'
                  numberAsText
                  digitsOnly
                  label={<>شماره پروانه گمرکی</>}
                  stateValue={patternFields.declarationNo}
                  isRequired={fieldRequired('scln')}
                  isReadonly={fieldReadOnly('scln')}
                  max={14}
                  hint={optionalCustomsHint}
                />
              </div>
            </>
          )}
          {isPrimaryField('scc', [1, 2, 7].includes(invoiceTemplate)) && (
            <div className='col-6 mt-7'>
              <CustomInputs
                type='text'
                numberAsText
                digitsOnly
                label={<>کد گمرک محل اظهار فروشنده</>}
                stateValue={patternFields.officeCode}
                isRequired={fieldRequired('scc')}
                isReadonly={fieldReadOnly('scc')}
                max={5}
                hint={optionalCustomsHint}
              />
            </div>
          )}
          {(fieldVisible('cdcn', invoiceTemplate === 7) ||
            fieldVisible('cdcd', invoiceTemplate === 7)) && (
            <>
              {isPrimaryField('cdcn', invoiceTemplate === 7) && (
                <div className='col-6 mt-7'>
                  <CustomInputs
                    type='text'
                    numberAsText
                    digitsOnly
                    label={<>شماره کوتاژ اظهارنامه گمرکی</>}
                    stateValue={patternFields.cottageNo}
                    isRequired={fieldRequired('cdcn')}
                    isReadonly={fieldReadOnly('cdcn')}
                    max={14}
                    hint={
                      <span className='text-gray-600 fs-8'>
                        اختیاری است؛ برای بهره‌مندی سیستمی از معافیت نرخ صفر مطابق اظهارنامه گمرکی
                        تکمیل شود.
                      </span>
                    }
                  />
                </div>
              )}
              {isPrimaryField('cdcd', invoiceTemplate === 7) && (
                <div className='col-6 mt-7'>
                  <CustomInputs
                    type='datepicker'
                    label={<>تاریخ کوتاژ اظهارنامه گمرکی</>}
                    stateValue={patternFields.cottageDate}
                    isRequired={fieldRequired('cdcd')}
                    isReadonly={fieldReadOnly('cdcd')}
                    limitToDate={date.date || now}
                    hint={
                      <span className='text-gray-600 fs-8'>
                        در صورت ورود، نباید بعد از تاریخ صورتحساب باشد.
                      </span>
                    }
                  />
                </div>
              )}
            </>
          )}
          {isPrimaryField('billid', invoiceTemplate === 5, true) && (
            <>
              <div className='col-6 mt-7'>
                <CustomInputs
                  type='text'
                  numberAsText
                  digitsOnly
                  isRequired={fieldRequired('billid', true)}
                  isReadonly={fieldReadOnly('billid')}
                  label={<>شماره اشتراک/شناسه قبض بهره بردار</>}
                  stateValue={patternFields.billNo}
                  max={19}
                  hint={requiredByDocumentHint}
                />
              </div>
            </>
          )}
          {(fieldVisible('asn', invoiceTemplate === 11) ||
            fieldVisible('asd', invoiceTemplate === 11)) && (
            <>
              {isPrimaryField('asn', invoiceTemplate === 11, true) && (
                <div className='col-6 mt-7'>
                  <CustomInputs
                    type='text'
                    digitsOnly
                    isRequired={fieldRequired('asn', true)}
                    isReadonly={fieldReadOnly('asn')}
                    label={<>شماره اعلامیه فروش بورس</>}
                    stateValue={{
                      value: stockExchangeInfo.saleAnnNo,
                      setValue: stockExchangeInfo.setSaleAnnNo,
                    }}
                    max={30}
                    hint='طبق سند V7.9 باید عددی و حداکثر ۳۰ رقم باشد.'
                  />
                </div>
              )}
              {isPrimaryField('asd', invoiceTemplate === 11, true) && (
                <div className='col-6 mt-7'>
                  <CustomInputs
                    type='datepicker'
                    isRequired={fieldRequired('asd', true)}
                    isReadonly={fieldReadOnly('asd')}
                    label={<>تاریخ اعلامیه فروش بورس</>}
                    stateValue={{
                      value: stockExchangeInfo.saleAnnDate,
                      setValue: stockExchangeInfo.setSaleAnnDate,
                    }}
                    limitToDate={date.date || now}
                    hint='تاریخ اعلامیه فروش نباید بعد از تاریخ صورتحساب باشد.'
                  />
                </div>
              )}
            </>
          )}
          {(fieldVisible('in', invoiceTemplate === 13) ||
            fieldVisible('an', invoiceTemplate === 13)) && (
            <>
              {isPrimaryField('in', invoiceTemplate === 13, true) && (
                <div className='col-6 mt-7'>
                  <CustomInputs
                    type='text'
                    numberAsText
                    digitsOnly
                    isRequired={fieldRequired('in', true)}
                    isReadonly={fieldReadOnly('in')}
                    label={<>شناسه یکتای بیمه نامه</>}
                    stateValue={patternFields.insPolicyNo}
                    max={12}
                    hint={
                      <span className='text-gray-600 fs-8'>
                        طبق سند V7.9 برای خدمات بیمه الزامی است؛ ۹ تا ۱۲ رقم.
                      </span>
                    }
                  />
                </div>
              )}
              {isPrimaryField('an', invoiceTemplate === 13) && (
                <div className='col-6 mt-7'>
                  <CustomInputs
                    type='text'
                    numberAsText
                    digitsOnly
                    label={<>شناسه یکتای الحاقیه</>}
                    stateValue={patternFields.extInsPolicyNo}
                    isRequired={fieldRequired('an')}
                    isReadonly={fieldReadOnly('an')}
                    max={12}
                    hint={
                      <span className='text-gray-600 fs-8'>
                        اختیاری است؛ در صورت ورود باید ۹ تا ۱۲ رقم باشد.
                      </span>
                    }
                  />
                </div>
              )}
            </>
          )}
          {invoiceTemplate == 8 && (
            <>
              <div className='col-6 mt-7'>
                <CustomInputs
                  type='text'
                  numberAsText
                  digitsOnly
                  isRequired
                  label={<>شماره بارنامه</>}
                  stateValue={patternFields.shipmentBlNumber}
                  max={18}
                  hint={requiredByDocumentHint}
                />
              </div>
              {(
                [
                  {
                    end: 'origin',
                    countryLabel: 'کشور مبدا',
                    cityLabel: 'شهر مبدا',
                    countryHelp: 'header.ocu',
                    cityHelp: 'header.oci',
                    country: patternFields.shipmentOriginCountry,
                    city: patternFields.shipmentOriginCity,
                  },
                  {
                    end: 'destination',
                    countryLabel: 'کشور مقصد',
                    cityLabel: 'شهر مقصد',
                    countryHelp: 'header.dco',
                    cityHelp: 'header.dci',
                    country: patternFields.shipmentDestinationCountry,
                    city: patternFields.shipmentDestinationCity,
                  },
                ] as const
              ).map((shipmentEnd) => {
                const cityRequired = isShipmentCityRequired(shipmentEnd.country.value)
                return (
                  <Fragment key={shipmentEnd.end}>
                    <div className='col-6 col-xl-3 mt-7'>
                      <ShipmentLocationSelect
                        kind='country'
                        inputId={`shipment-${shipmentEnd.end}-country`}
                        label={shipmentEnd.countryLabel}
                        helpKey={shipmentEnd.countryHelp}
                        isRequired
                        value={shipmentEnd.country.value}
                        onChange={(code) => {
                          shipmentEnd.country.setValue(code)
                          if (!isShipmentCityRequired(code)) shipmentEnd.city.setValue('')
                        }}
                      />
                    </div>
                    <div className='col-6 col-xl-3 mt-7'>
                      <ShipmentLocationSelect
                        kind='city'
                        inputId={`shipment-${shipmentEnd.end}-city`}
                        label={shipmentEnd.cityLabel}
                        helpKey={shipmentEnd.cityHelp}
                        isRequired={cityRequired}
                        isDisabled={!cityRequired && !shipmentEnd.city.value}
                        value={shipmentEnd.city.value}
                        onChange={shipmentEnd.city.setValue}
                        hint={
                          cityRequired ? undefined : (
                            <span className='text-gray-600 fs-8'>
                              جدول سازمان فقط شهرهای ایران را دارد؛ برای کشور دیگر شهر ثبت نمی‌شود.
                            </span>
                          )
                        }
                      />
                    </div>
                  </Fragment>
                )
              })}
              <div className='col-6 mt-7'>
                <CustomInputs
                  type='text'
                  numberAsText
                  digitsOnly
                  isRequired
                  label={<>شناسه فرستنده</>}
                  stateValue={patternFields.shipmentSenderEconomicCode}
                  max={12}
                  hint={
                    <span className='text-gray-600 fs-8'>
                      شماره ملی، شناسه ملی، شناسه مشارکت یا کد فراگیر.
                    </span>
                  }
                />
              </div>
              <div className='col-6 mt-7'>
                <CustomInputs
                  type='text'
                  numberAsText
                  digitsOnly
                  isRequired
                  label={<>شناسه گیرنده</>}
                  stateValue={patternFields.shipmentReceiverEconomicCode}
                  max={12}
                  hint={
                    <span className='text-gray-600 fs-8'>
                      شماره ملی، شناسه ملی، شناسه مشارکت یا کد فراگیر.
                    </span>
                  }
                />
              </div>
              <div className='col-6 mt-7'>
                <CustomInputs
                  type='radio'
                  isRequired
                  label={<>نوع حمل/بارنامه</>}
                  stateValue={patternFields.shipmentTransportType}
                  items={[
                    {label: 'جاده‌ای', value: '1'},
                    {label: 'ریلی', value: '2'},
                    {label: 'هوایی', value: '3'},
                    {label: 'دریایی', value: '4'},
                  ]}
                />
              </div>
              <div className='col-6 mt-7'>
                <CustomInputs
                  type='text'
                  isRequired
                  label={<>شماره ناوگان</>}
                  stateValue={patternFields.shipmentFleetNumber}
                  max={20}
                  hint={
                    <span className='text-gray-600 fs-8'>
                      جاده‌ای: VIN خودرو، ریلی: شماره قطار، هوایی: شماره پرواز، دریایی: شماره کشتی.
                    </span>
                  }
                />
              </div>
              <div className='col-6 mt-7'>
                <CustomInputs
                  type='text'
                  numberAsText
                  digitsOnly
                  isRequired={patternFields.shipmentTransportType.value == '1'}
                  label={<>شماره ملی/کد فراگیر راننده</>}
                  stateValue={patternFields.shipmentDriverIdCode}
                  max={12}
                  hint='شماره ملی ۱۰ رقمی یا کد فراگیر ۱۲ رقمی اتباع غیرایرانی.'
                  error={getDriverIdCodeValidationError(patternFields.shipmentDriverIdCode.value)}
                />
              </div>
            </>
          )}
          {isPrimaryField(
              'crn',
              invoiceType.invoiceType === 1 && [1, 2, 3, 4].includes(invoiceTemplate),
              invoiceTemplate === 4
            ) && (
              <div className='col-6 mt-7'>
                <CustomInputs
                  type='number'
                  label='شناسه یکتا ثبت قرارداد پیمانکاری'
                  isRequired={fieldRequired('crn', invoiceTemplate === 4)}
                  isReadonly={fieldReadOnly('crn')}
                  numberAsText
                  stateValue={{
                    value: contractCode.contractCode,
                    setValue: contractCode.setContractCode,
                  }}
                  max={12}
                  hint={contractCodeHint}
                />
              </div>
            )}
          <div className='col-12'>
            <AutoOpenOptionalSection title='اطلاعات تکمیلی و اختیاری' hasValue={hasOptionalData}>
              <div className='row'>
                {!isBuyerRequired && buyerField}
                {invoiceTemplate === 6 && (
                  <>
                    <div className='col-6 mt-7'>
                      <CustomInputs
                        type='text'
                        label={<>نام مسافر</>}
                        stateValue={patternFields.flightFirstName}
                      />
                    </div>
                    <div className='col-6 mt-7'>
                      <CustomInputs
                        type='text'
                        label={<>نام خانوادگی مسافر</>}
                        stateValue={patternFields.flightLastName}
                      />
                    </div>
                    <div className='col-6 mt-7'>
                      <CustomInputs
                        type='text'
                        numberAsText
                        digitsOnly
                        label={<>شماره اقتصادی خریدار بلیط</>}
                        stateValue={patternFields.flightEconomicCode}
                        max={14}
                        hint={
                          <span className='text-gray-600 fs-8'>
                            برای بهره‌مندی خریدار از اعتبار مالیاتی تکمیل شود: ۱۱ رقم برای خریدار
                            حقوقی و ۱۴ رقم برای خریدار حقیقی. اگر خریدار انتخاب نشده باشد، همین
                            شماره به‌عنوان شماره اقتصادی خریدار ارسال می‌شود.
                          </span>
                        }
                      />
                    </div>
                    <div className='col-6 mt-7'>
                      <CustomInputs
                        type='text'
                        label={<>نام آژانس فروش</>}
                        stateValue={patternFields.flightAgentName}
                      />
                    </div>
                    <div className='col-6 mt-7'>
                      <CustomInputs
                        type='text'
                        numberAsText
                        digitsOnly
                        label={<>شماره اقتصادی آژانس</>}
                        max={14}
                        stateValue={patternFields.flightAgentEconomicCode}
                        hint={
                          <span className='text-gray-600 fs-8'>
                            در صورت صدور صورتحساب توسط شرکت هواپیمایی و فروش توسط آژانس، شماره
                            اقتصادی آژانس درج شود.
                          </span>
                        }
                      />
                    </div>
                  </>
                )}
                {isOptionalField('scln', [1, 2].includes(invoiceTemplate)) && (
                  <div className='col-6 mt-7'>
                    <CustomInputs
                      type='text'
                      numberAsText
                      digitsOnly
                      label={<>شماره پروانه گمرکی</>}
                      stateValue={patternFields.declarationNo}
                      isReadonly={fieldReadOnly('scln')}
                      max={14}
                      hint={optionalCustomsHint}
                    />
                  </div>
                )}
                {isOptionalField('scc', [1, 2, 7].includes(invoiceTemplate)) && (
                  <div className='col-6 mt-7'>
                    <CustomInputs
                      type='text'
                      numberAsText
                      digitsOnly
                      label={<>کد گمرک محل اظهار فروشنده</>}
                      stateValue={patternFields.officeCode}
                      isReadonly={fieldReadOnly('scc')}
                      max={5}
                      hint={optionalCustomsHint}
                    />
                  </div>
                )}
                {isOptionalField('cdcn', invoiceTemplate === 7) && (
                  <div className='col-6 mt-7'>
                    <CustomInputs
                      type='text'
                      numberAsText
                      digitsOnly
                      label={<>شماره کوتاژ اظهارنامه گمرکی</>}
                      stateValue={patternFields.cottageNo}
                      isReadonly={fieldReadOnly('cdcn')}
                      max={14}
                      hint={
                        <span className='text-gray-600 fs-8'>
                          برای بهره‌مندی سیستمی از معافیت نرخ صفر مطابق اظهارنامه گمرکی تکمیل شود.
                        </span>
                      }
                    />
                  </div>
                )}
                {isOptionalField('cdcd', invoiceTemplate === 7) && (
                  <div className='col-6 mt-7'>
                    <CustomInputs
                      type='datepicker'
                      label={<>تاریخ کوتاژ اظهارنامه گمرکی</>}
                      stateValue={patternFields.cottageDate}
                      isReadonly={fieldReadOnly('cdcd')}
                      limitToDate={date.date || now}
                      hint='در صورت ورود، نباید بعد از تاریخ صورتحساب باشد.'
                    />
                  </div>
                )}
                {isOptionalField('billid', invoiceTemplate === 5, true) && (
                  <div className='col-6 mt-7'>
                    <CustomInputs
                      type='text'
                      numberAsText
                      isReadonly={fieldReadOnly('billid')}
                      label={<>شماره اشتراک/شناسه قبض بهره بردار</>}
                      stateValue={patternFields.billNo}
                      max={19}
                    />
                  </div>
                )}
                {isOptionalField('asn', invoiceTemplate === 11, true) && (
                  <div className='col-6 mt-7'>
                    <CustomInputs
                      type='text'
                      digitsOnly
                      isReadonly={fieldReadOnly('asn')}
                      label={<>شماره اعلامیه فروش بورس</>}
                      stateValue={{
                        value: stockExchangeInfo.saleAnnNo,
                        setValue: stockExchangeInfo.setSaleAnnNo,
                      }}
                      max={30}
                    />
                  </div>
                )}
                {isOptionalField('asd', invoiceTemplate === 11, true) && (
                  <div className='col-6 mt-7'>
                    <CustomInputs
                      type='datepicker'
                      isReadonly={fieldReadOnly('asd')}
                      label={<>تاریخ اعلامیه فروش بورس</>}
                      stateValue={{
                        value: stockExchangeInfo.saleAnnDate,
                        setValue: stockExchangeInfo.setSaleAnnDate,
                      }}
                      limitToDate={date.date || now}
                    />
                  </div>
                )}
                {isOptionalField('in', invoiceTemplate === 13, true) && (
                  <div className='col-6 mt-7'>
                    <CustomInputs
                      type='text'
                      numberAsText
                      isReadonly={fieldReadOnly('in')}
                      label={<>شناسه یکتای بیمه نامه</>}
                      stateValue={patternFields.insPolicyNo}
                      max={12}
                    />
                  </div>
                )}
                {isOptionalField('an', invoiceTemplate === 13) && (
                  <div className='col-6 mt-7'>
                    <CustomInputs
                      type='text'
                      numberAsText
                      label={<>شناسه یکتای الحاقیه</>}
                      stateValue={patternFields.extInsPolicyNo}
                      isReadonly={fieldReadOnly('an')}
                      max={12}
                    />
                  </div>
                )}
                {invoiceTemplate === 8 && (
                  <>
                    <div className='col-6 mt-7'>
                      <CustomInputs
                        type='text'
                        numberAsText
                        label={<>شماره بارنامه مرجع</>}
                        stateValue={patternFields.shipmentRefBlNumber}
                        max={18}
                        hint='در صورت صدور بارنامه جدید به دنبال ابطال بارنامه قبلی تکمیل شود.'
                      />
                    </div>
                    <div className='col-6 mt-7'>
                      <CustomInputs
                        type='number'
                        label={<>مجموع وزن بارنامه</>}
                        stateValue={patternFields.shipmentTotalWeight}
                      />
                    </div>
                  </>
                )}
                <div className={clsx(`col-${invoiceType.invoiceType == 1 ? '6' : '12'}`, 'mt-7')}>
                  <CustomInputs
                    type='textarea'
                    label='توضیحات در باکس خریدار'
                    stateValue={{
                      value: buyerDescription.buyerDescription,
                      setValue: buyerDescription.setBuyerDescription,
                    }}
                    hint={buyerType2Hint}
                  />
                </div>
                {isOptionalField(
                  'crn',
                  invoiceType.invoiceType === 1 && [1, 2, 3, 4].includes(invoiceTemplate),
                  invoiceTemplate === 4
                ) && (
                  <div className='col-6 mt-7'>
                    <CustomInputs
                      type='number'
                      label='شناسه یکتا ثبت قرارداد پیمانکاری'
                      isReadonly={fieldReadOnly('crn')}
                      numberAsText
                      stateValue={{
                        value: contractCode.contractCode,
                        setValue: contractCode.setContractCode,
                      }}
                      max={12}
                      hint={contractCodeHint}
                    />
                  </div>
                )}
              </div>
            </AutoOpenOptionalSection>
          </div>
        </div>
      </div>
      {notNew && (
        <div className='text-gray-600 d-flex flex-row'>
          <div className='me-2'>{notEditableElement} :</div>
          <div>
            <p>
              برای تغییر این اطلاعات، باید صورتحساب را ابطال کنید. برای این کار، از ستون عملیات در
              جدول، گزینه «ابطال» را انتخاب کنید.
              {/* <br />
              <span className='link-danger' onClick={ebtal}>
                یا می‌توانید از اینجا نسبت به ابطال مستقیم صورتحساب اقدام کنید.
              </span> */}
            </p>
          </div>
        </div>
      )}
      {addCustomer && (
        <CustomerEditModal
          closeFn={() => {
            setAddCustomer(false)
          }}
          callBack={(data) => {
            setBuyerSearch({
              label: data?.nm,
              value: data?.id,
            })
            setAddCustomer(false)
          }}
        />
      )}
    </>
  )
}

export {Step1}
